export type UserTreatmentProps = {
  id: string | undefined
  treatmentID: string
  startDate: Date
  endDate: Date | null
  startCron?: Date | null
  endCron?: Date | null
  duration: number
  frequency: number
  quantity: number
  reason: string
  userID: string
  creatorID?: string
  currently: boolean
}

export class UserTreatment {
  private readonly _id: string | undefined
  private readonly _treatmentID: string
  private readonly _startDate: Date
  private readonly _endDate: Date | null
  private readonly _startCron?: Date | null
  private readonly _endCron?: Date | null
  private readonly _duration: number
  private readonly _frequency: number
  private readonly _quantity: number
  private readonly _reason: string
  private readonly _userID: string
  private readonly _creatorID?: string
  private _currently: boolean

  constructor(p: UserTreatmentProps) {
    this._id = p.id
    this._treatmentID = p.treatmentID
    this._startDate = p.startDate
    this._endDate = p.endDate
    this._startCron = p.startCron
    this._endCron = p.endCron
    this._duration = p.duration
    this._frequency = p.frequency
    this._quantity = p.quantity
    this._reason = p.reason
    this._userID = p.userID
    this._creatorID = p.creatorID
    this._currently = p.currently
  }

  get id(): string | undefined {
    return this._id
  }

  get treatmentID(): string {
    return this._treatmentID
  }

  get startDate(): Date {
    return this._startDate
  }

  get endDate(): Date | null {
    return this._endDate
  }

  get startCron(): Date | null | undefined {
    return this._startCron
  }

  get endCron(): Date | null | undefined {
    return this._endCron
  }

  get duration(): number {
    return this._duration
  }

  get frequency(): number {
    return this._frequency
  }

  get quantity(): number {
    return this._quantity
  }

  get reason(): string {
    return this._reason
  }

  get userID(): string {
    return this._userID
  }

  get creatorID(): string | undefined {
    return this._creatorID
  }

  get currently(): boolean {
    return this._currently
  }

  set currently(value: boolean) {
    this._currently = value
  }
}

export interface UserTreatmentQuery {
  treatmentID?: string
  userID?: string
  currently?: boolean
  startDate?: Date
}
